import Vue from 'vue'
import { createAndMountInstance } from 'util/loader-helper'
import log from 'util/logger'
import { widgetLibraries } from 'init/command-queue'
import { ChatterConfig as IChatterConfig } from 'services/api-service'
import chatterConfig, { loadConfig } from './chatter.config'
import ChatterWidget from './chatter'

let root: Vue

export const type = 'chatter'

export function initialize() {
  return createAndMountInstance(root, ChatterWidget, chatterConfig.widgetDivId)
    .then(instance => root = instance)
    .catch(e => log.warn(`Exeception loading chatter widget: ${e}`))
}

export function loadWidget(widgetConfig: IChatterConfig): Promise<void> {
  return new Promise((resolve) => {
    loadConfig(widgetConfig)
    // no chatter specific commands yet.  The widget does respond to global command 'set'.
    widgetLibraries.chatter = {}
    initialize().then(() => resolve())
  })
}

export function getInstance() {
  return root
}
